export const validateLeadForm = (data) => {
    const errors = {};
  
    if (!data.firstName || data.firstName.trim() === '') {
      errors.firstName = 'First Name is required';
    } else if (data.firstName.length > 50) {
      errors.firstName = 'First Name cannot exceed 50 characters';
    }
  
    if (!data.lastName || data.lastName.trim() === '') {
      errors.lastName = 'Last Name is required';
    } else if (data.lastName.length > 50) {
      errors.lastName = 'Last Name cannot exceed 50 characters';
    }
  
    if (!data.email || data.email.trim() === '') {
      errors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(data.email)) {
      errors.email = 'Invalid email format';
    }
  
    if (data.phone && !/^\d{10,15}$/.test(data.phone)) {
      errors.phone = 'Invalid phone number (10-15 digits)';
    }
  
  if (!data.message || data.message.trim() === '') {
    errors.message = 'Message is required';
  } else if (data.message.length > 500) {
    errors.message = 'Message cannot exceed 500 characters';
  }

  if (data.service && data.service.length > 20) {
    errors.service = 'Service selection is invalid';
  }

  return errors;
  };
  